/**
 * Dynamic quantity-break prices for custom selling plans.
 * Stores subscription + one-time prices on data attrs, toggles display from #auto_refill / plan radios.
 */
(function () {
  'use strict';

  var QB_DEBUG = true;

  function qbLog() {
    if (!QB_DEBUG || typeof console === 'undefined' || !console.log) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[QB Price]');
    console.log.apply(console, args);
  }

  function isSubscriptionActive() {
    var autoRefill = document.getElementById('auto_refill');
    if (autoRefill) return !!autoRefill.checked;

    var subscribeInput = document.querySelector('.subscribe-input');
    var onetimeInput = document.querySelector('.onetime-input');
    if (subscribeInput && onetimeInput) {
      return !!subscribeInput.checked;
    }
    if (subscribeInput) {
      return !!subscribeInput.checked;
    }

    return true;
  }

  function isSubscriptionToggle(el) {
    if (!el) return false;
    if (el.id === 'auto_refill') return true;
    if (el.classList && (el.classList.contains('subscribe-input') || el.classList.contains('onetime-input'))) {
      return true;
    }
    if (el.closest && el.closest('.auto-refill') && el.type === 'checkbox') return true;
    return false;
  }

  function labelForQuantityRadio(radio) {
    var label = radio.nextElementSibling;
    if (label && label.tagName === 'LABEL' && radio.id && label.getAttribute('for') === radio.id) {
      return label;
    }
    if (radio.id) {
      var byFor = document.querySelector('label[for="' + radio.id + '"]');
      if (byFor) return byFor;
    }
    return null;
  }

  function looksLikeZeroMoney(str) {
    if (!str || !String(str).trim()) return true;
    var n = parseFloat(String(str).replace(/[^\d.]/g, ''));
    return !Number.isFinite(n) || n <= 0;
  }

  function parseMoneyToNumber(str) {
    if (!str) return 0;
    var s = String(str).trim();
    if (!s || /\{\{/.test(s)) return 0;

    s = s.replace(/[^\d.,-]/g, '');
    if (!s) return 0;

    var lastComma = s.lastIndexOf(',');
    var lastDot = s.lastIndexOf('.');

    if (lastComma > lastDot) {
      s = s.replace(/\./g, '').replace(',', '.');
    } else if (lastDot > lastComma) {
      s = s.replace(/,/g, '');
    } else if (lastComma >= 0) {
      var afterComma = s.length - lastComma - 1;
      s = afterComma <= 2 ? s.replace(',', '.') : s.replace(/,/g, '');
    }

    var n = parseFloat(s);
    return Number.isFinite(n) ? n : 0;
  }

  function qbNormalizePlanId(raw) {
    var s = String(raw).trim();
    if (!s) return '';
    var parts = s.split('/');
    return String(parts[parts.length - 1]).trim();
  }

  function qbFormatAmountUs(n) {
    var parts = n.toFixed(2).split('.');
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
  }

  function qbFormatAmountEuropean(n) {
    var parts = n.toFixed(2).split('.');
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
  }

  function qbFormatIntUs(n) {
    return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function qbFormatIntEuropean(n) {
    return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function qbFormatCentsWithShopMoneyFormat(cents, format) {
    var moneyFormat = format || '${{amount}}';
    var n = Number(cents) / 100;
    if (!Number.isFinite(n)) return '';

    var amountUs = qbFormatAmountUs(n);
    var amountEuropean = qbFormatAmountEuropean(n);
    var noDecimalsUs = qbFormatIntUs(n);
    var noDecimalsEuropean = qbFormatIntEuropean(n);

    var out = String(moneyFormat);
    out = out.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/gi, noDecimalsEuropean);
    out = out.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/gi, amountEuropean);
    out = out.replace(/\{\{\s*amount_no_decimals\s*\}\}/gi, noDecimalsUs);
    out = out.replace(/\{\{\s*amount\s*\}\}/gi, amountUs);

    if (/\{\{/.test(out)) {
      out = out.replace(/\{\{\s*amount[^}]*\}\}/gi, amountUs);
    }

    return out;
  }

  function qbFormatMoneyCents(cents, format) {
    return qbFormatCentsWithShopMoneyFormat(cents, format);
  }

  function qbFormatMoneyNoTrailingZeros(cents, format) {
    return qbFormatMoneyCents(cents, format)
      .replace(/(\d)\.00(?!\d)/, '$1')
      .replace(/(\d),00(?!\d)/, '$1');
  }

  function qbCurrentVariantId() {
    var el = document.querySelector('product-info input[name="id"], form[action*="/cart/add"] input[name="id"]');
    return el && el.value ? String(el.value).trim() : '';
  }

  function qbSubscriptionSaveDisplayCents(saveSubCents) {
    return Math.ceil(saveSubCents / 100) * 100;
  }

  function qbSubscriptionDiscountPercent(compareCents, subCents) {
    if (!compareCents || compareCents <= 0 || !Number.isFinite(subCents) || subCents >= compareCents) {
      return 0;
    }
    return Math.round(((compareCents - subCents) / compareCents) * 100);
  }

  function qbCompareUnitPrice(v, compareMode, rule) {
    var price = v.price;
    var cmp = v.compare_at_price;
    if (compareMode !== 'compare_price') return price;
    if (rule === 'gt_zero') {
      return cmp != null && cmp > 0 ? cmp : price;
    }
    return cmp != null && cmp > price ? cmp : price;
  }

  function qbSellingPlanJsonOnPage() {
    return document.querySelector('script[id^="qb-selling-plan-prices-"]');
  }

  function qbDynamicSpPricesOnPage() {
    return document.querySelector('quantity-breaks[data-qb-dynamic-sp-prices="true"]');
  }

  function qbGetSelectedQuantityRadio() {
    return document.querySelector('.quantity-breaks-container input[name="quantity"]:checked');
  }

  function qbGetProductCartForm() {
    var wrapper = document.querySelector('.product__info-wrapper');
    if (!wrapper) return null;

    var productFormEl = wrapper.querySelector('product-form.product-form') || wrapper.querySelector('product-form');
    if (!productFormEl) return null;

    return productFormEl.querySelector('form[action="/cart/add"]') || productFormEl.querySelector('form');
  }

  function qbEnsureSellingPlanInput(form) {
    if (!form) return null;
    var input = form.querySelector('input[name="selling_plan"]');
    if (input) return input;

    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'selling_plan';
    input.className = 'selling_plan_id';
    form.appendChild(input);
    return input;
  }

  function qbPlanIdFromRadio(radio) {
    if (!radio) return '';
    var raw = radio.getAttribute('data-selling-plan');
    return raw ? qbNormalizePlanId(raw) : '';
  }

  function qbSyncCartFormFromQuantityBreak() {
    var form = qbGetProductCartForm();
    if (!form) {
      qbLog('sync form – cart form not found');
      return;
    }

    var radio = qbGetSelectedQuantityRadio();
    var variantId = radio ? String(radio.getAttribute('variant') || '').trim() : '';
    var planId = qbPlanIdFromRadio(radio);
    var sub = isSubscriptionActive();
    var sellingPlanInput = qbEnsureSellingPlanInput(form);
    var autoRefill = document.getElementById('auto_refill');

    if (variantId) {
      form.querySelectorAll('input[name="id"]').forEach(function (input) {
        input.value = variantId;
      });
      document.querySelectorAll('.product-variant-id').forEach(function (input) {
        if (!form.contains(input)) return;
        input.value = variantId;
      });
    }

    var activePlanId = sub && planId ? planId : '';

    if (sellingPlanInput) {
      sellingPlanInput.value = activePlanId;
    }

    document.querySelectorAll('.product__info-wrapper input[name="selling_plan"], .selling_plan_id').forEach(function (input) {
      input.value = activePlanId;
    });

    if (autoRefill && planId) {
      autoRefill.value = planId;
    }

    qbLog('sync form', {
      variantId: variantId,
      planId: activePlanId,
      dataPlan: planId,
      subscription: sub
    });
  }

  function qbUpdateAutoRefillDiscountLabel() {
    var textEl = document.querySelector('[data-auto-refill-discount-text]');
    if (!textEl) return;

    if (!textEl.hasAttribute('data-auto-refill-discount-template')) {
      textEl.setAttribute('data-auto-refill-discount-template', String(textEl.textContent || '').trim());
    }

    var template = textEl.getAttribute('data-auto-refill-discount-template') || '';
    if (!template) return;

    var radio = qbGetSelectedQuantityRadio();
    var percent = radio ? String(radio.getAttribute('data-save-subscription-percent') || '').trim() : '';
    if (!percent || percent === '0') {
      textEl.textContent = template;
      return;
    }

    var updated = template;
    if (/\d+\s*%/.test(template)) {
      updated = template.replace(/\d+\s*%/, percent + '%');
    } else if (/\[subscription_discount_percent\]/.test(template)) {
      updated = template.replace(/\[subscription_discount_percent\]/g, percent);
    } else {
      updated = template;
    }

    textEl.textContent = updated;
    qbLog('auto-refill discount label', { percent: percent, text: updated });
  }

  function qbScheduleFormSync() {
    qbSyncCartFormFromQuantityBreak();
    qbUpdateAutoRefillDiscountLabel();
    setTimeout(function () {
      qbSyncCartFormFromQuantityBreak();
      qbUpdateAutoRefillDiscountLabel();
    }, 0);
    setTimeout(function () {
      qbSyncCartFormFromQuantityBreak();
      qbUpdateAutoRefillDiscountLabel();
    }, 100);
  }

  function qbFindVariant(variants, id) {
    if (!id) return null;
    var s = String(id).trim();
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === s) return variants[i];
    }
    return null;
  }

  function qbLookupUnitSub(plans, planRaw) {
    if (!planRaw || !plans) return null;
    var normalized = qbNormalizePlanId(planRaw);

    if (plans[planRaw] != null) return plans[planRaw];
    if (plans[normalized] != null) return plans[normalized];
    if (plans[String(normalized)] != null) return plans[String(normalized)];

    var keys = Object.keys(plans);
    for (var i = 0; i < keys.length; i++) {
      if (keys[i] === normalized || String(keys[i]) === String(normalized) || qbNormalizePlanId(keys[i]) === normalized) {
        return plans[keys[i]];
      }
    }
    return null;
  }

  function qbResolveOptionUnitSub(spMap, radio) {
    var variantId = String(radio.getAttribute('variant') || '').trim();
    var planRaw = radio.getAttribute('data-selling-plan');
    if (!variantId || !planRaw) {
      return { unitSub: null, variantId: variantId, planRaw: planRaw };
    }

    var plans = spMap[variantId] && spMap[variantId].plans ? spMap[variantId].plans : {};
    var unitSub = qbLookupUnitSub(plans, planRaw);
    return {
      unitSub: unitSub,
      planUsed: qbNormalizePlanId(planRaw),
      variantId: variantId,
      availablePlans: Object.keys(plans)
    };
  }

  function qbPriceEl(label) {
    return label.querySelector('.quantity-break__right .quantity-break__price') || label.querySelector('.quantity-break__price');
  }

  function qbCompareEl(label) {
    return label.querySelector('.quantity-break__right .quantity-break__compare-price') || label.querySelector('.quantity-break__compare-price');
  }

  function qbSetPriceText(el, formatted) {
    if (!el || formatted == null) return;
    var span = el.querySelector('.qb-dynamic-sp-price-value') || el.querySelector('span');
    if (span) {
      span.textContent = formatted;
    } else {
      el.textContent = formatted;
    }
  }

  function qbDispatchPricesUpdated() {
    document.dispatchEvent(new CustomEvent('qb:prices-updated'));
  }

  function qbSyncAttrs(source, target) {
    if (!source || !target) return;
    ['data-price-subscription', 'data-price-onetime', 'data-compare-subscription'].forEach(function (attr) {
      var val = source.getAttribute(attr);
      if (val != null) target.setAttribute(attr, val);
    });
  }

  function qbApplyDynamicSpPriceToggle() {
    if (!qbDynamicSpPricesOnPage()) return;

    var sub = isSubscriptionActive();
    qbLog('toggle apply | subscription active:', sub);

    document.querySelectorAll('quantity-breaks[data-qb-dynamic-sp-prices="true"] .quantity-breaks-container input[name="quantity"]').forEach(function (radio) {
      var label = labelForQuantityRadio(radio);
      if (!label) {
        qbLog('skip option – label not found for', radio.id || radio.value);
        return;
      }

      var priceEl = qbPriceEl(label);
      var compareEl = qbCompareEl(label);

      if (!priceEl) {
        qbLog('skip option – no .quantity-break__price for', radio.id || radio.value);
        return;
      }

      if (priceEl) qbSyncAttrs(radio, priceEl);
      if (compareEl) qbSyncAttrs(radio, compareEl);

      var subPrice = radio.getAttribute('data-price-subscription') || priceEl.getAttribute('data-price-subscription');
      var onePrice = radio.getAttribute('data-price-onetime') || priceEl.getAttribute('data-price-onetime');
      var compareSub = radio.getAttribute('data-compare-subscription') || (compareEl && compareEl.getAttribute('data-compare-subscription'));

      var activePrice = sub ? subPrice : onePrice;
      if (!activePrice) {
        qbLog('skip option – missing prices for', radio.id || radio.value, { subPrice: subPrice, onePrice: onePrice });
        return;
      }

      if (!priceEl.classList.contains('variant-price-update')) {
        qbSetPriceText(priceEl, activePrice);
      }

      radio.setAttribute('data-price', activePrice);

      if (compareEl && !compareEl.classList.contains('variant-price-update')) {
        if (sub && compareSub && parseMoneyToNumber(compareSub) > parseMoneyToNumber(subPrice || activePrice)) {
          compareEl.classList.remove('hidden');
          qbSetPriceText(compareEl, compareSub);
        } else {
          compareEl.classList.add('hidden');
        }
      }

      var saveWrap = label.querySelector('[data-quantity-break-save]');
      if (saveWrap) {
        var saveRow = saveWrap.closest('.quantity-break__right-row--save');
        if (saveRow) {
          if (sub && compareSub && subPrice && parseMoneyToNumber(compareSub) > parseMoneyToNumber(subPrice)) {
            saveRow.classList.remove('hidden');
          } else {
            saveRow.classList.add('hidden');
          }
        }
      }

      qbLog(radio.id || ('qty-' + radio.value), {
        subscription: subPrice,
        onetime: onePrice,
        compare: compareSub,
        showing: activePrice,
        mode: sub ? 'subscription' : 'one-time'
      });
    });

    qbDispatchPricesUpdated();
  }

  function qbRefreshDynamicSpPriceAttrs() {
    if (!qbDynamicSpPricesOnPage()) return;

    document.querySelectorAll('quantity-breaks[data-qb-dynamic-sp-prices="true"]').forEach(function (root) {
      var blockId = root.getAttribute('data-qb-block-id');
      var spEl = root.querySelector('#qb-selling-plan-prices-' + blockId);
      var vEl = root.querySelector('#quantity-breaks-variants-' + blockId);
      if (!vEl) return;

      var spMap = {};
      if (spEl) {
        try {
          spMap = JSON.parse(spEl.textContent);
        } catch (e) {
          spMap = {};
        }
      }

      var variants;
      try {
        variants = JSON.parse(vEl.textContent);
      } catch (e) {
        return;
      }

      var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';

      root.querySelectorAll('.quantity-breaks-container input[name="quantity"]').forEach(function (radio) {
        var label = labelForQuantityRadio(radio);
        if (!label) return;

        var optionVariantId = String(radio.getAttribute('variant') || '').trim();
        var v = qbFindVariant(variants, optionVariantId);
        if (!v) {
          qbLog('refresh – variant not found for', radio.id || radio.value, optionVariantId);
          return;
        }

        var pctLeft = parseFloat(label.getAttribute('data-percentage-left'));
        if (!Number.isFinite(pctLeft)) pctLeft = 1;
        var fixedDiscount = parseInt(label.getAttribute('data-fixed-discount'), 10) || 0;
        var qty = parseInt(label.getAttribute('data-quantity'), 10) || parseInt(radio.value, 10) || 1;

        var onetimeCents = Math.round(v.price * qty * pctLeft - fixedDiscount);
        var compareCents = v.price * qty;
        var resolved = qbResolveOptionUnitSub(spMap, radio);
        var subCents = resolved.unitSub != null ? resolved.unitSub * qty : onetimeCents;

        var subStr = qbFormatMoneyNoTrailingZeros(subCents, moneyFormat);
        var oneStr = qbFormatMoneyNoTrailingZeros(onetimeCents, moneyFormat);
        var compareStr = qbFormatMoneyNoTrailingZeros(compareCents, moneyFormat);
        var saveSub = compareCents - subCents;
        if (saveSub < 0) saveSub = 0;
        var saveStr = qbFormatMoneyCents(qbSubscriptionSaveDisplayCents(saveSub), moneyFormat);
        var savePercent = qbSubscriptionDiscountPercent(compareCents, subCents);

        radio.setAttribute('data-price-subscription', subStr);
        radio.setAttribute('data-price-onetime', oneStr);
        radio.setAttribute('data-compare-subscription', compareStr);
        radio.setAttribute('data-save-subscription', saveStr);
        radio.setAttribute('data-save-subscription-percent', String(savePercent));

        if (resolved.unitSub == null) {
          qbLog('refresh – no selling plan price for', radio.id || radio.value, resolved);
        } else {
          qbLog('refresh', radio.id || radio.value, {
            variantId: optionVariantId,
            planUsed: resolved.planUsed,
            subscription: subStr,
            onetime: oneStr,
            compare: compareStr
          });
        }

        var priceEl = qbPriceEl(label);
        var compareEl = qbCompareEl(label);
        if (priceEl) {
          priceEl.setAttribute('data-price-subscription', subStr);
          priceEl.setAttribute('data-price-onetime', oneStr);
          priceEl.setAttribute('data-compare-subscription', compareStr);
          priceEl.setAttribute('data-save-subscription', saveStr);
          priceEl.setAttribute('data-save-subscription-percent', String(savePercent));
        }
        if (compareEl) {
          compareEl.setAttribute('data-compare-subscription', compareStr);
        }
      });
    });
  }

  function qbUpdateDynamicSubscriptionSaves() {
    if (!qbSellingPlanJsonOnPage()) return;

    document.querySelectorAll('quantity-breaks[data-qb-block-id]').forEach(function (root) {
      var blockId = root.getAttribute('data-qb-block-id');
      var spEl = root.querySelector('#qb-selling-plan-prices-' + blockId);
      var vEl = root.querySelector('#quantity-breaks-variants-' + blockId);
      if (!spEl || !vEl) return;

      var spMap;
      var variants;
      try {
        spMap = JSON.parse(spEl.textContent);
      } catch (e) {
        return;
      }
      try {
        variants = JSON.parse(vEl.textContent);
      } catch (e) {
        return;
      }

      var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';

      root.querySelectorAll('.quantity-breaks-container input[name="quantity"]').forEach(function (radio) {
        var label = labelForQuantityRadio(radio);
        if (!label) return;

        var optionVariantId = String(radio.getAttribute('variant') || '').trim();
        var v = qbFindVariant(variants, optionVariantId);
        if (!v) return;

        var resolved = qbResolveOptionUnitSub(spMap, radio);
        if (resolved.unitSub == null) return;

        var qty = parseInt(label.getAttribute('data-quantity'), 10) || parseInt(radio.value, 10) || 1;
        var compareTotal = v.price * qty;
        var subTotal = resolved.unitSub * qty;
        var saveSub = compareTotal - subTotal;
        if (saveSub < 0) saveSub = 0;

        var displayCents = qbSubscriptionSaveDisplayCents(saveSub);
        var savePercent = qbSubscriptionDiscountPercent(compareTotal, subTotal);
        radio.setAttribute('data-save-subscription', qbFormatMoneyCents(displayCents, moneyFormat));
        radio.setAttribute('data-save-subscription-percent', String(savePercent));
      });
    });
  }

  function updateQuantityBreakSaveLines() {
    qbRefreshDynamicSpPriceAttrs();
    qbUpdateDynamicSubscriptionSaves();
    qbApplyDynamicSpPriceToggle();

    var sub = isSubscriptionActive();
    document.querySelectorAll('.quantity-breaks-container input[name="quantity"]').forEach(function (radio) {
      var label = labelForQuantityRadio(radio);
      if (!label) return;
      var saveWrap = label.querySelector('[data-quantity-break-save]');
      if (!saveWrap) return;
      var amtEl = saveWrap.querySelector('[data-quantity-break-save-amount]');
      if (!amtEl) return;

      var qbRoot = radio.closest('quantity-breaks');
      if (qbRoot && qbRoot.getAttribute('data-qb-dynamic-sp-prices') === 'true' && !sub) {
        saveWrap.classList.add('hidden');
        amtEl.textContent = '';
        return;
      }

      var raw = (sub ? radio.getAttribute('data-save-subscription') : radio.getAttribute('data-save-onetime')) || '';
      var text = String(raw).trim();

      if (!text || looksLikeZeroMoney(text)) {
        saveWrap.classList.add('hidden');
        amtEl.textContent = '';
        return;
      }
      saveWrap.classList.remove('hidden');
      amtEl.textContent = text;
    });

    qbUpdateAutoRefillDiscountLabel();
    qbDispatchPricesUpdated();
  }

  function scheduleToggleApply() {
    qbApplyDynamicSpPriceToggle();
    setTimeout(qbApplyDynamicSpPriceToggle, 100);
    setTimeout(qbApplyDynamicSpPriceToggle, 300);
  }

  function scheduleFullUpdate() {
    setTimeout(updateQuantityBreakSaveLines, 0);
    if (qbDynamicSpPricesOnPage()) {
      setTimeout(updateQuantityBreakSaveLines, 100);
    }
    qbScheduleFormSync();
  }

  function qbBindQuantityBreakListeners() {
    document.querySelectorAll('.quantity-breaks-container input[name="quantity"]').forEach(function (r) {
      r.addEventListener('change', qbScheduleFormSync);
    });
  }

  function qbBindVariantIdListeners() {
    var seen = new WeakSet();
    document.querySelectorAll('product-info input[name="id"], form[action*="/cart/add"] input[name="id"]').forEach(function (el) {
      if (seen.has(el)) return;
      seen.add(el);
      el.addEventListener('change', scheduleFullUpdate);
      el.addEventListener('input', scheduleFullUpdate);
    });
  }

  function init() {
    qbLog('init | dynamic blocks:', document.querySelectorAll('quantity-breaks[data-qb-dynamic-sp-prices="true"]').length);

    if (qbSellingPlanJsonOnPage() || qbDynamicSpPricesOnPage() || document.querySelector('.quantity-breaks-container input[name="quantity"]')) {
      qbBindVariantIdListeners();
      qbBindQuantityBreakListeners();
    }

    updateQuantityBreakSaveLines();
    qbScheduleFormSync();

    document.addEventListener('change', function (e) {
      if (isSubscriptionToggle(e.target)) {
        qbLog('subscription toggle changed:', e.target.id || e.target.className, 'checked:', e.target.checked);
        scheduleToggleApply();
        scheduleFullUpdate();
        return;
      }

      if (e.target && e.target.matches && e.target.matches('.quantity-breaks-container input[name="quantity"]')) {
        scheduleFullUpdate();
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(init, 0);
    });
  } else {
    setTimeout(init, 0);
  }
})();
